import { FireCMSTranslations } from "../types/translations";

export const de: FireCMSTranslations = {
    // ─── Form actions ────────────────────────────────────────────
    save: "Speichern",
    create: "Erstellen",
    create_copy: "Kopie erstellen",
    save_and_close: "Speichern und schließen",
    create_copy_and_close: "Kopie erstellen und schließen",
    create_and_close: "Erstellen und schließen",
    discard: "Verwerfen",
    clear: "Löschen",
    cancel: "Abbrechen",

    // ─── Entity actions ──────────────────────────────────────────
    edit: "Bearbeiten",
    copy: "Kopieren",
    delete: "Löschen",

    // ─── Delete dialog ───────────────────────────────────────────
    delete_confirmation_title: "Löschen?",
    delete_confirmation_body: "Dadurch wird die Entität gelöscht. Sind Sie sicher?",
    delete_multiple_confirmation_body: "Dadurch werden die ausgewählten Entitäten gelöscht. Sind Sie sicher?",

    // ─── Unsaved-changes dialog ───────────────────────────────────
    unsaved_changes_title: "Ungespeicherte Änderungen",
    unsaved_changes_body: "Sie haben ungespeicherte Änderungen. Möchten Sie diese verwerfen?",
    discard_changes: "Änderungen verwerfen",
    keep_editing: "Weiter bearbeiten",

    // ─── Collection table / toolbar ──────────────────────────────
    search: "Suchen",
    find_by_id: "Nach ID suchen",
    find_entity_by_id: "Entität nach ID suchen",
    filter: "Filter",
    filters: "Filter",
    clear_filter: "Filter löschen",
    clear_filter_sort: "Filter/Sortierung löschen",
    clear_sort: "Sortierung löschen",
    no_items: "Keine Elemente",
    no_entries_found: "Keine Einträge gefunden",
    all_entries_loaded: "Alle {{count}} Einträge geladen",
    create_your_first_entry: "Erstellen Sie Ihren ersten Eintrag",
    no_results_filter_sort: "Keine Ergebnisse mit angewendetem Filter/Sortierung",
    add: "Hinzufügen",
    remove: "Entfernen",
    multiple_entities: "Mehrere Entitäten",
    unsaved_changes: "Sie haben ungespeicherte Änderungen in {{collectionName}}.",
    so_empty: "So leer...",
    no_results: "Keine Ergebnisse mit angewendetem Filter/Sortierung",
    refresh_data: "Daten aktualisieren",
    dark_mode: "Dunkel",
    light_mode: "Hell",
    system_mode: "System",
    ok: "Ok",
    save_collection_config: "Sammlungsstruktur speichern",
    search_for_more_icons: "Nach weiteren Symbolen suchen…",
    ai_modified: "KI-modifiziert",
    size_label: "Größe",
    group_by: "Gruppieren nach",
    initialize_kanban_order: "Kanban-Reihenfolge initialisieren",
    copy_id: "ID kopieren",
    add_specific: "{{name}} hinzufügen",
    select_specific: "{{name}} auswählen",
    select_from: "Aus {{name}} auswählen",
    done: "Fertig",
    log_out: "Abmelden",
    license_needed: "Lizenz erforderlich",
    license_description: "Sie benötigen eine gültige Lizenz, um FireCMS PRO zu verwenden. Bitte wenden Sie sich an {{email}} für weitere Informationen.",
    column_cannot_be_edited: "Diese Spalte kann nicht direkt bearbeitet werden",
    close: "Schließen",
    unsaved_local_changes: "Ungespeicherte lokale Änderungen",
    unsaved_local_changes_description: "Dieses Dokument wurde lokal bearbeitet und weist ungespeicherte Änderungen auf. Diese lokalen Änderungen gehen verloren, wenn Sie sie nicht anwenden.",
    preview_changes: "Änderungen in der Vorschau anzeigen",
    apply_changes: "Änderungen anwenden",
    discard_local_changes: "Lokale Änderungen verwerfen",
    preview_local_changes: "Lokale Änderungen in der Vorschau anzeigen",
    preview_local_changes_description: "Dies sind die lokalen Änderungen, die auf das Formular angewendet werden.",
    type: "Typ",
    string: "Zeichenfolge",
    number: "Zahl",
    boolean: "Boolescher Wert",
    date: "Datum",
    map: "Karte",
    array: "Array",
    arrays_of_arrays_not_supported: "Arrays von Arrays werden nicht unterstützt.",
    data_type_not_supported: "Datentyp {{dataType}} wird noch nicht unterstützt",
    passkey_error_unsupported: "Ihr Gerät oder Browser unterstützt keine Passkeys.",

    admin: "Admin",
    home: "Startseite",
    this_form_has_errors: "Dieses Formular enthält Fehler",
    error_loading_navigation: "Fehler beim Laden der Navigation",
    error_loading_auth: "Fehler beim Laden der Authentifizierung",
    this_form_has_been_modified: "Dieses Formular wurde geändert",
    current_form_in_sync: "Das aktuelle Formular ist mit der Datenbank synchron",
    open_in_console: "In der Konsole öffnen",
    collection_does_not_exist: "Die angegebene Sammlung existiert nicht. Überprüfen Sie die Konsole",
    unexpected_value: "Unerwarteter Wert",
    unexpected_value_click_to_edit: "Unerwarteter Wert. Klicken zum Bearbeiten",
    unexpected_reference_value: "Unerwarteter Referenzwert. Klicken zum Bearbeiten",
    copy_url_to_clipboard: "URL in Zwischenablage kopieren",
    open_image_in_new_tab: "Bild in neuem Tab öffnen",
    reference_not_set: "Referenz nicht gesetzt",
    reference_does_not_exist: "Referenz existiert nicht",
    entity_not_found: "Entität nicht gefunden",
    file_not_found: "Datei nicht gefunden",
    unsaved_changes_in_entity: "Sie haben ungespeicherte Änderungen in dieser Entität.",
    delete_this_role: "Diese Rolle löschen",
    no_roles_yet: "Sie haben noch keine Rollen.",
    create_default_roles: "Standardrollen erstellen",
    delete_role_confirmation: "Sind Sie sicher, dass Sie diese Rolle löschen möchten?",
    delete_this_user: "Diesen Benutzer löschen",
    no_users_yet: "Es gibt noch keine Benutzer",
    add_logged_user_as_admin: "Den angemeldeten Benutzer als Administrator hinzufügen",
    add_current_user_as_admin: "Aktuellen Benutzer als Administrator hinzufügen",
    create_default_roles_and_add_admin: "Standardrollen erstellen und aktuellen Benutzer als Administrator hinzufügen",
    delete_user_confirmation: "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
    create_your_users_and_roles: "Erstellen Sie Ihre Benutzer und Rollen",
    no_users_or_roles_defined: "Sie haben keine Benutzer oder Rollen definiert. Sie können Standardrollen erstellen und den aktuellen Benutzer als Administrator hinzufügen.",
    save_before_changing_schema: "Sie müssen das Dokument speichern, bevor Sie das Schema ändern können",
    edit_schema_for_this_form: "Schema für dieses Formular bearbeiten",
    no_permissions_to_edit_collection: "Sie haben keine Berechtigung, diese Sammlung zu bearbeiten",
    browser_does_not_support_audio: "Ihr Browser unterstützt das Audioelement nicht.",
    user_not_found: "Benutzer nicht gefunden: {{value}}",

    // ─── Collection view actions ──────────────────────────────────
    delete_selected: "Löschen",
    cannot_delete_selected: "Sie haben mindestens eine Entität ausgewählt, die Sie nicht löschen können",

    // ─── Array / field containers ─────────────────────────────────
    add_entry: "Hinzufügen",
    add_on_top: "Oben hinzufügen",
    add_below: "Unten hinzufügen",
    add_to_field: "Zu {{fieldName}} hinzufügen",
    value: "Wert",
    key: "Schlüssel",
    drag_drop_multiple: "Ziehen Sie einige Dateien hierher oder klicken Sie, um Dateien auszuwählen. Ziehen zum Neuordnen.",
    drag_drop_single: "Ziehen Sie eine Datei hierher oder klicken Sie, um eine auszuwählen",

    // ─── Navigation / scaffold ────────────────────────────────────
    open_menu: "Menü öffnen",
    close_drawer: "Schublade schließen",
    navigation_drawer: "Navigationsschublade",

    // ─── Error states ─────────────────────────────────────────────
    error: "Fehler",
    error_uploading_file: "Fehler beim Hochladen der Datei",
    error_deleting: "Fehler beim Löschen",
    error_before_delete: "Fehler vor dem Löschen",
    error_updating_asset: "Fehler beim Aktualisieren des Assets",
    error_deleting_asset: "Fehler beim Löschen des Assets",
    error_firestore_index: "Für diese Abfrage ist ein Firestore-Index erforderlich.",
    create_index: "Index erstellen",
    value_is_not_reference: "Wert ist keine Referenz.",
    click_to_edit: "Klicken zum Bearbeiten",
    data_is_not_array_of_references: "Daten sind kein Array von Referenzen",

    // ─── Misc ─────────────────────────────────────────────────────
    loading: "Wird geladen",
    local_changes_applied: "Lokale Änderungen auf das Formular angewendet",
    local_changes_discarded: "Lokale Änderungen verworfen",
    are_you_sure_leave: "Sind Sie sicher, dass Sie diese Seite verlassen möchten?",
    see_console_details: "Weitere Details siehe Konsole.",
    drop_here_create_group: "Hier ablegen, um eine neue Gruppe zu erstellen",
    filter_for_null_values: "Nach Nullwerten filtern",
    value_updated_elsewhere: "Dieser Wert wurde anderswo aktualisiert",
    add_property: "Eigenschaft hinzufügen",
    edit_name: "Bearbeiten {{name}}",
    this_entity_not_exist: "Diese Entität existiert nicht in der Datenbank",
    internal_error: "Interner FEHLER",

    // ─── Rename group dialog ──────────────────────────────────────
    rename_group: "Gruppe umbenennen",
    group_name_label: "Gruppenname",
    group_name_empty_error: "Gruppenname darf nicht leer sein.",
    group_name_exists_error: "Dieser Gruppenname existiert bereits.",

    // ─── Search ───────────────────────────────────────────────────
    search_collections: "Sammlungen durchsuchen",

    // ─── Navigation groups ────────────────────────────────────────
    views_group: "Ansichten",

    // ─── Entity Edit View ─────────────────────────────────────────
    youd_need_to_save_before_additional_collections: "Sie müssen Ihre Entität speichern, bevor Sie weitere Sammlungen hinzufügen können",

    // ─── Not Found Page ───────────────────────────────────────────
    page_not_found: "Seite nicht gefunden",
    page_not_found_body: "Diese Seite existiert nicht oder Sie haben möglicherweise keinen Zugriff darauf",
    back_to_home: "Zurück zur Startseite",

    // ─── Collection Editor ─────────────────────────────────────────
    default_collection_view: "Standard-Sammlungsansicht",
    table_view: "Tabelle",
    cards_view: "Karten",
    kanban_view: "Kanban",
    choose_how_entities_displayed_default: "Wählen Sie aus, wie Entitäten standardmäßig angezeigt werden sollen",

    document_view: "Dokumentenansicht",
    side_panel: "Seitenbereich",
    full_screen: "Vollbild",
    should_documents_opened_full_screen: "Sollen Dokumente im Vollbildmodus oder in einem Inline-Seitendialog geöffnet werden",

    select_custom_view: "Benutzerdefinierte Ansicht auswählen",
    no_custom_views_defined: "Keine benutzerdefinierten Ansichten definiert. Definieren Sie Ihre benutzerdefinierten Ansichten in den Anpassungseinstellungen, bevor Sie diesen Dialog verwenden.",

    select_custom_action: "Benutzerdefinierte Aktion auswählen",
    no_custom_actions_defined: "Keine benutzerdefinierten Aktionen definiert. Definieren Sie Ihre benutzerdefinierten Aktionen in den Anpassungseinstellungen, bevor Sie diesen Dialog verwenden.",

    no_collections_found: "Keine Sammlungen gefunden",
    start_building_collections: "Beginnen Sie einfach mit dem Erstellen von Sammlungen in FireCMS. Ordnen Sie sie Ihren bestehenden Datenbankdaten zu, importieren Sie sie aus Dateien oder verwenden Sie unsere Vorlagen.",
    create_first_collection: "Erstellen Sie Ihre erste Sammlung",
    define_collections_programmatically: "Sie können Sammlungen auch programmgesteuert definieren.",
    edit_collection: "Sammlung bearbeiten",
    no_permissions_edit_collection: "Sie haben keine Berechtigung, diese Sammlung zu bearbeiten",
    no_permissions_create_collection: "Sie haben keine Berechtigung, Sammlungen zu erstellen",
    create_collection: "Sammlung erstellen",
    update_collection: "Sammlung aktualisieren",

    new_collection: "Neue Sammlung",
    add_new_collection: "Neue Sammlung hinzufügen",
    collection_with_name: "Sammlung {{name}}",
    change_icon: "Symbol ändern",
    is_subcollection_of: "Dies ist eine Untersammlung von",
    name: "Name",
    collection_name_description: "Name dieser Sammlung, normalerweise im Plural (z. B. Produkte)",
    path: "Pfad",
    relative_path_to_parent: "Relativer Pfad zum übergeordneten Element (der übergeordnete Pfad muss nicht eingeschlossen werden)",
    path_in_database: "Pfad, in dem diese Sammlung in der Datenbank gespeichert ist",
    singular_name: "Bezeichnung im Singular",
    singular_name_description: "Definieren Sie optional einen Singularnamen für Ihre Entitäten",
    description: "Beschreibung",
    description_of_collection: "Beschreibung der Sammlung, Sie können Markdown verwenden",
    collection_id: "Sammlungs-ID",
    collection_id_description: "Diese ID identifiziert diese Sammlung. Typischerweise identisch mit dem Pfad.",
    collection_group: "Sammlungsgruppe",
    collection_group_description: "Eine Sammlungsgruppe besteht aus allen Sammlungen mit demselben Pfad. Auf diese Weise können Sie über mehrere Sammlungen gleichzeitig abfragen.",
    advanced_settings: "Erweiterte Einstellungen",
    doc_history_global: "Dokumentverlaufsrevisionen aktiviert, falls global aktiviert",
    doc_history_enabled: "Dokumentverlaufsrevisionen AKTIVIERT",
    doc_history_not_enabled: "Dokumentverlaufsrevisionen NICHT aktiviert",
    doc_history_description: "Wenn diese Option aktiviert ist, verfügt jedes Dokument in dieser Sammlung über einen Änderungsverlauf. Dies ist nützlich für Überwachungszwecke. Die Daten werden in einer Untersammlung des Dokuments in Ihrer Datenbank namens __history gespeichert.",
    document_id_generation: "Generierung von Dokument-IDs",
    code_defined: "Code definiert",
    users_must_define_id: "Benutzer müssen eine ID definieren",
    users_can_define_id: "Benutzer können eine ID definieren, dies ist jedoch nicht erforderlich",
    doc_id_auto_generated: "Dokument-ID wird automatisch generiert",
    config_doc_id_generation: "Konfigurieren Sie, wie Dokument-IDs beim Erstellen neuer Entitäten generiert werden.",
    enable_text_search: "Textsuche für diese Sammlung aktivieren",
    text_search_description: "Erlauben Sie die Textsuche für diese Sammlung. Wenn Sie keinen Delegaten für die Textsuche angegeben haben, wird die integrierte lokale Textsuche verwendet. Dies wird für große Sammlungen nicht empfohlen, da dies zu Leistungs- und Kostenproblemen führen kann.",
    database_id: "Datenbank-ID",
    default_text: "(Standard)",

    custom_actions: "Benutzerdefinierte Aktionen",
    more_info: "Mehr Infos",
    define_custom_actions_cli: "Definieren Sie Ihre eigenen benutzerdefinierten Aktionen, indem Sie sie mit der CLI hochladen.",
    action_defined_in_code: "Diese Aktion ist im Code definiert mit dem Schlüssel",
    add_custom_entity_action: "Benutzerdefinierte Entitätsaktion hinzufügen",
    remove_this_action: "Diese Aktion entfernen?",
    remove_action_warning: "Dadurch werden keine Daten gelöscht, sondern nur die Aktion im CMS",

    subcollections_of: "Untersammlungen von",
    add_subcollection: "Untersammlung hinzufügen",
    custom_views: "Benutzerdefinierte Ansichten",
    define_custom_views_cli: "Definieren Sie Ihre eigenen benutzerdefinierten Ansichten, indem Sie sie mit der CLI hochladen.",
    view_defined_in_code: "Diese Ansicht ist im Code definiert mit dem Schlüssel",
    add_custom_entity_view: "Benutzerdefinierte Entitätsansicht hinzufügen",
    delete_this_subcollection: "Diese Untersammlung löschen?",
    remove_collection_warning: "Dadurch werden keine Daten gelöscht, sondern nur die Sammlung im CMS",
    remove_this_view: "Diese Ansicht entfernen?",
    remove_view_warning: "Dadurch werden keine Daten gelöscht, sondern nur die Ansicht im CMS",

    no_collection_selected: "Keine Sammlung ausgewählt",
    code_for_collection: "Code für",
    use_config_define_json: "Verwenden Sie diese Konfiguration, um die Sammlung im JSON-Format zu definieren.",
    customise_collection_code: "Wenn Sie die Sammlung im Code anpassen möchten, können Sie diesen Sammlungscode zu Ihrer CMS-App-Konfiguration hinzufügen.",
    copied: "Kopiert",

    property_cant_be_edited: "Diese Eigenschaft kann nicht bearbeitet werden",
    property_not_editable_description: "Sie haben möglicherweise keine Berechtigung zum Bearbeiten oder es ist im Code mit dem auf False gesetzten Flag 'editable' definiert.",
    delete_this_property: "Diese Eigenschaft löschen?",
    delete_property_warning: "Dadurch werden keine Daten gelöscht, nur die Sammlung wird geändert.",
    error_must_specify_id: "Sie müssen eine ID für das Feld angeben",
    error_id_format: "Die ID darf nur Buchstaben, Zahlen und Unterstriche (_) enthalten und nicht mit einer Zahl beginnen",
    error_id_already_exists: "Es gibt bereits ein anderes Feld mit dieser ID",
    error_must_specify_title: "Sie müssen einen Titel für das Feld angeben",
    custom_or_other: "Benutzerdefiniert/Andere",
    select_property_widget: "Wählen Sie ein Eigenschafts-Widget aus",
    error_changing_data_type: "Dieses Widget verwendet einen anderen Datentyp als das ursprünglich ausgewählte Widget. Dies kann zu Fehlern bei vorhandenen Daten führen.",
    required: "Erforderlich",

    enum_form_dialog: "Enum-Formulardialog",
    imported_data_preview: "Vorschau der importierten Daten",
    entities_with_same_id_overwritten: "Entitäten mit derselben ID werden überschrieben",
    collection_editor: "Sammlungseditor",
    properties_in_this_group: "Eigenschaften in dieser Gruppe",
    data_property_mapping: "Daten-Eigenschafts-Zuordnung",
    property_edit_view: "Ansicht Eigenschaft bearbeiten",
    all_of_these: "Alle von diesen",
    any_of_these: "Eine von diesen",

    only_admins_edit_roles: "Nur Administratoren können Rollen bearbeiten",
    error_user_not_found: "Benutzer nicht gefunden",
    role: "Rolle",
    name_of_this_role: "Name dieser Rolle",
    id_of_this_role: "ID dieser Rolle",
    create_entities: "Entitäten erstellen",
    read_entities: "Entitäten lesen",
    update_entities: "Entitäten aktualisieren",
    delete_entities: "Entitäten löschen",
    all_collections: "Alle Sammlungen",
    create_entities_in_collections: "Entitäten in Sammlungen erstellen",
    access_all_data_in_every_collection: "Auf alle Daten in jeder Sammlung zugreifen",
    update_data_in_any_collection: "Daten in einer beliebigen Sammlung aktualisieren",
    delete_data_in_any_collection: "Daten in einer beliebigen Sammlung löschen",
    allow_all_permissions_in_this_collections: "Alle Berechtigungen in diesen Sammlungen zulassen",
    all: "Alle",
    customise_permissions_description: "Sie können die Berechtigungen anpassen, die die mit dieser Rolle verknüpften Benutzer für die Entitäten jeder Sammlung ausführen können",
    create_collections: "Sammlungen erstellen",
    yes: "Ja",
    no: "Nein",
    can_user_create_collections: "Kann der Benutzer Sammlungen erstellen",
    edit_collections: "Sammlungen bearbeiten",
    only_own_collections: "Nur seine/ihre eigenen",
    own: "Eigene",
    can_user_edit_collections: "Kann der Benutzer Sammlungen bearbeiten",
    delete_collections: "Sammlungen löschen",
    can_user_delete_collections: "Kann der Benutzer Sammlungen löschen",
    error_saving_role: "Beim Speichern dieser Rolle ist ein Fehler aufgetreten",
    create_role: "Rolle erstellen",
    update: "Aktualisieren",

    only_admins_change_roles: "Nur Administratoren können Rollen ändern",
    must_be_at_least_one_admin: "Es muss mindestens einen Administrator geben",
    logged_user_not_found: "Angemeldeter Benutzer nicht gefunden",
    user: "Benutzer",
    user_id: "Benutzer-ID",
    name_of_this_user: "Name dieses Benutzers",
    email_of_this_user: "E-Mail dieses Benutzers",
    roles: "Rollen",
    create_user: "Benutzer erstellen",

    users: "Benutzer",
    add_user: "Benutzer hinzufügen",
    add_role: "Rolle hinzufügen",
    is_admin: "Ist Administrator",
    default_permissions: "Standardberechtigungen",
    created_on: "Erstellt am",
    email: "E-Mail",
    id: "ID",
    read: "Lesen",

    column_in_file: "Spalte in der Datei",
    map_to_property: "Zuordnung zur Eigenschaft",
    default_values: "Standardwerte",
    default_values_description: "Sie können einen Standardwert für nicht zugeordnete Spalten und leere Werte auswählen:",
    property: "Eigenschaft",
    default_value: "Standardwert",
    autogenerate_id: "ID automatisch generieren",
    id_column_description: "Spalte, die als ID für jedes Dokument verwendet wird",
    do_not_set_value: "Wert nicht festlegen",
    set_value_to_true: "Wert auf true setzen",
    set_value_to_false: "Wert auf false setzen",
    drag_and_drop_file: "Datei hierher ziehen und ablegen oder zum Hochladen klicken",
    error_saving_data: "Fehler beim Speichern der Daten",
    retry: "Wiederholen",
    saving_data: "Daten speichern",
    entities_saved: "Entitäten gespeichert",
    do_not_close_tab: "Schließen Sie diesen Tab nicht, da sonst der Import unterbrochen wird",
    import: "Importieren",
    import_data: "Daten importieren",
    upload_file_description: "Laden Sie eine CSV-, Excel- oder JSON-Datei hoch und ordnen Sie sie Ihrem vorhandenen Schema zu",
    back: "Zurück",
    next: "Weiter",
    save_data: "Daten speichern",
    use_column_as_id: "Diese Spalte als ID verwenden",
    do_not_import_property: "Diese Eigenschaft nicht importieren",
    entities_will_be_overwritten: "Entitäten mit derselben ID werden überschrieben",
    data_imported_successfully: "Daten erfolgreich importiert",
    export: "Exportieren",
    export_data: "Daten exportieren",
    download_table_csv: "Laden Sie den Inhalt dieser Tabelle als CSV-Datei herunter",
    csv: "CSV",
    json: "JSON",
    dates_as_timestamps: "Daten als Zeitstempel",
    dates_as_strings: "Daten als Zeichenfolgen",
    flatten_arrays: "Arrays glätten",
    download: "Herunterladen",
    large_number_of_documents: "Diese Sammlung hat eine große Anzahl von Dokumenten ({{count}}).",
    include_undefined_values: "Undefinierte Werte einschließen",
    submit: "Einreichen",

    no_filterable_properties: "Keine filterbaren Eigenschaften verfügbar",
    apply_filters: "Filter anwenden",
    list: "Liste",
    cards: "Karten",
    board: "Board",
    initialize_kanban_order_desc: "Dadurch werden allen Elementen, die keine haben, fortlaufende Auftragswerte zugewiesen. Die Elemente behalten ihre aktuelle Reihenfolge innerhalb jeder Spalte bei.",
    kanban_view_not_available: "Kanban-Ansicht ist nicht verfügbar",
    kanban_view_requires_enum: "Die Kanban-Ansicht erfordert eine String-Eigenschaft mit Enum-Werten, um Entitäten in Spalten zu gruppieren. Bitte fügen Sie dem Schema Ihrer Sammlung eine Enum-Eigenschaft hinzu, um diese Ansicht zu verwenden.",
    no_enum_values_configured: 'Keine Enum-Werte für Eigenschaft "{{property}}" konfiguriert',
    items_need_backfill: "Einige Elemente haben keine Reihenfolge. Initialisieren Sie sie, um das Verschieben per Drag-and-Drop zu aktivieren.",
    initialize: "Initialisieren",
    confirm_multiple_delete: "Mehrfaches Löschen bestätigen?",
    delete_entity_confirm_title: "Möchten Sie dieses {{entityName}} löschen?",

    /** Recently extracted strings for collection editor */
    /** AI Collection Generator Popover */
    generate_collection_with_ai: "Sammlung mit KI generieren",
    modify_collection_with_ai: "Sammlung mit KI ändern",
    describe_collection_to_create: "Beschreibe die Sammlung, die du erstellen möchtest.",
    describe_changes_to_make: "Beschreibe die Änderungen, die du an dieser Sammlung vornehmen möchtest.",
    ai_placeholder_create: "z. B. Erstelle eine Produktsammlung mit Name, Preis, Beschreibung und Kategorie...",
    ai_placeholder_modify: "z. B. Füge ein Miniaturbild-Feld mit Speicher hinzu, mache den Preis erforderlich...",
    ai_assist: "KI-Assistent",
    generating: "Generiere...",

    this_is_subcollection_of: "Dies ist eine Untersammlung von",
    use_existing_paths_database: "Verwenden Sie einen der vorhandenen Pfade in Ihrer Datenbank:",
    describe_collection_ai: "Beschreiben Sie Ihre Sammlung für KI:",
    generate_with_ai: "Mit KI generieren",
    create_from_json_config: "Aus JSON-Konfiguration erstellen:",
    paste_json_config: "JSON-Konfiguration einfügen",
    create_collection_from_file_formats: "Eine Sammlung aus einer Datei erstellen (csv, json, xls, xslx...)",
    select_template: "Wählen Sie eine Vorlage:",
    products: "Produkte",
    collection_products_subtitle: "Eine Sammlung von Produkten mit Bildern, Preisen und Lagerbestand",
    collection_users_subtitle: "Eine Sammlung von Benutzern mit E-Mails, Namen und Rollen",
    blog_posts: "Blogbeiträge",
    collection_blog_posts_subtitle: "Eine Sammlung von Blogbeiträgen mit Bildern, Autoren und komplexen Inhalten",
    pages: "Seiten",
    collection_pages_subtitle: "Eine Sammlung von Seiten mit Bildern, Autoren und komplexen Inhalten",
    continue_from_scratch: "Von vorne beginnen",

    /** Admin views config */
    cms_users: "CMS-Benutzer",
    roles_menu: "Rollen",
    project_settings: "Projekteinstellungen",

    // ─── FireCMS Cloud Login ──────────────────────────────────────
    build_admin_panel_in_minutes: "Erstellen Sie Ihr Firebase Admin Panel in wenigen Minuten",
    go_live_instantly: "Sofort live gehen:",
    create_production_ready_back_offices: "Erstellen Sie produktionsreife Back-Offices",
    without_the_frontend_hassle: "ohne Frontend-Aufwand.",
    automatic_setup: "Automatische Einrichtung",
    from_your_existing_firestore_data: "aus Ihren bestehenden Firestore-Daten.",
    seamless_real_time_firebase_integration: "Nahtlose Firebase-Integration in Echtzeit.",
    intuitive_spreadsheet_like_ui: "Intuitive Oberfläche im Tabellenstil",
    your_whole_team_can_use: "die Ihr ganzes Team nutzen kann.",
    focus_on_your_app: "Konzentrieren Sie sich auf Ihre App,",
    not_the_admin_panel: "nicht auf das Admin-Panel.",
    join_our_newsletter: "Melden Sie sich für unseren Newsletter an. Kein Spam, nur wichtige Updates!",
    by_signing_in_you_agree_to_our: "Mit der Anmeldung stimmen Sie unseren",
    terms_and_conditions: "Allgemeinen Geschäftsbedingungen",
    and_our: "und unserer",
    privacy_policy: "Datenschutzerklärung",
    firecms_cloud_google_disclosure: "Die Nutzung der von Google-APIs erhaltenen Informationen durch die FireCMS Cloud sowie deren Weitergabe an andere Apps erfolgt in Übereinstimmung mit der",
    google_api_services_user_data_policy: "Nutzerdatenrichtlinie für Google API-Dienste",
    including_the_limited_use_requirements: "einschließlich der Anforderungen zur eingeschränkten Nutzung.",
    email_password: "E-Mail/Passwort",
    sign_in_with_google: "Über Google anmelden",

    // --- Auth error messages ---
    auth_user_not_found: "Benutzer nicht gefunden",
    auth_wrong_password: "Falsches Passwort. Bitte versuchen Sie es erneut.",
    auth_user_disabled: "Benutzer deaktiviert. Bitte kontaktieren Sie den Support.",
    auth_account_exists_with_different_credential: "Konto existiert mit anderer Anmeldemethode",
    auth_email_already_in_use: "Die E-Mail wird bereits verwendet",
    auth_google_permissions_required: "Sie müssen zusätzliche Berechtigungen erteilen, um Ihre Google Cloud-Projekte verwalten zu können",
    auth_invalid_email_password: "Bitte geben Sie sowohl E-Mail als auch Passwort ein",
    auth_enter_email_first: "Bitte geben Sie zuerst Ihre E-Mail ein",
    auth_password_reset_sent: "E-Mail zum Zurücksetzen des Passworts gesendet",
    auth_sign_in_account: "Melden Sie sich in Ihrem Konto an",
    auth_create_new_account: "Neues Konto erstellen",
    auth_password: "Passwort",
    auth_reset_password: "Passwort zurücksetzen",
    auth_new_user: "Neuer Benutzer?",
    auth_have_account: "Haben Sie bereits ein Konto?",
    auth_sign_in: "Anmelden",
    auth_sign_up: "Registrieren",

    // --- SaaS Subscriptions ---
    subscriptions: "Abonnements",
    manage_your_subscriptions_in_stripe: "Verwalten Sie Ihre Abonnements in Stripe",
    go_to_your_stripe_portal: "Gehen Sie in Ihr Stripe-Benutzerportal, um den Rechnungsverlauf einzusehen. Beachten Sie, dass Sie auch die Abonnements des angemeldeten Benutzers verwalten können.",
    your_pro_licenses: "Ihre PRO-Lizenzen",
    create_new_license: "Neue Lizenz erstellen",
    create_subscriptions_in_this_section: "Erstellen Sie in diesem Abschnitt Abonnements nur für das selbstgehostete FireCMS PRO. Wenn Sie die FireCMS Cloud verwenden, können Sie Ihr Projekt in den Projekteinstellungen upgraden.",
    if_you_are_an_agency: "Wenn Sie eine Agentur sind, können Sie Ihre Lizenz frei an Ihre Kunden weiterverkaufen.",
    if_you_have_any_questions: "Wenn Sie Fragen haben oder Hilfe benötigen, kontaktieren Sie uns unter",
    you_have_not_created_any_pro_licenses: "Sie haben noch keine FireCMS PRO-Lizenzen erstellt",
    archive: "Archivieren",
    licensed_projects_lowercase: "lizenzierte projekte",
    manage: "Verwalten",
    update_payment_method: "Zahlungsmethode aktualisieren",
    your_firecms_cloud_projects: "Ihre FireCMS Cloud Projekte",
    status_active: "Aktiv",
    status_trialing: "Testphase",
    status_past_due: "Überfällig",
    status_canceled: "Gekündigt",
    status_unpaid: "Unbezahlt",
    status_incomplete: "Unvollständig",
    status_incomplete_expired: "Unvollständig (abgelaufen)",
    status_unknown: "Unbekannt",

    plan_free: "Nicht abonniert",
    plan_cloud_plus: "Abonniert",
    plan_pro: "Pro",
    plan_unknown: "Unbekannter Plan",

    auto_setup_collections_button: "Sammlungen automatisch einrichten",
    auto_setup_collections_title: "Sammlungen automatisch einrichten?",
    auto_setup_collections_desc: "Dadurch werden automatisch Sammlungskonfigurationen für Sammlungen erstellt, die noch <b>NICHT</b> zugeordnet sind.",
    this_can_take_a_minute: "Dies kann ein bis zwei Minuten dauern",
    no_collections_found_to_setup: "Keine einzurichtenden Sammlungen gefunden",
    collections_have_been_setup: "Sammlungen wurden automatisch eingerichtet",
    error_setting_up_collections: "Fehler beim automatischen Einrichten der Sammlungen",
    add_your: "Fügen Sie Ihre",
    database_collections: "Datenbanksammlungen",
    to_firecms: "zu FireCMS hinzu",
    no_unmapped_collections: "Keine nicht zugeordneten Sammlungen",
    query_and_update_with_datatalk: "Fragen Sie Ihre Daten in natürlicher Sprache ab und aktualisieren Sie sie mit DATATALK",
    welcome_to_firecms: "Willkommen bei FireCMS",
    admin_panel_ready_bring_data: "Ihr Admin-Panel ist bereit. Bringen Sie Ihre Daten ein.",
    admin_panel_ready_get_started: "Ihr Admin-Panel ist bereit. So können Sie loslegen.",
    auto_detect_collections: "Sammlungen automatisch erkennen",
    auto_detect_collections_desc: "Lassen Sie die KI Ihre Datenbank scannen und Sammlungs-Schemata automatisch generieren.",
    create_a_collection: "Eine Sammlung erstellen",
    create_collection_desc: "Definieren Sie Ihre erste Sammlung manuell mit dem visuellen Editor.",
    read_the_docs: "Dokumentation lesen",
    read_the_docs_desc: "Erfahren Sie, wie Sie Felder, Ansichten, Aktionen und mehr anpassen können.",
    explore_docs: "Dokumentation erkunden",
    want_to_customize_with_code: "Möchten Sie mit Code anpassen? Führen Sie aus:",
    to_scaffold_a_local_project: "um ein lokales Projekt zu erstellen",

    // ─── Collection Editor — Validation ──────────────────────────
    validation: "Validierung",
    unique: "Einzigartig",
    required_message: "Pflichtfeld-Nachricht",
    required_tooltip: "Sie können diese Entität nicht speichern, wenn dieser Wert nicht gesetzt ist",
    unique_tooltip: "Es darf nicht mehrere Entitäten mit demselben Wert geben",
    lowercase: "Kleinbuchstaben",
    uppercase: "Großbuchstaben",
    trim: "Leerzeichen entfernen",
    exact_length: "Exakte Länge",
    min_length: "Mindestlänge",
    max_length: "Maximale Länge",
    matches_regex: "Entspricht Regex",
    not_valid_regexp: "Kein gültiger regulärer Ausdruck",
    regex_helper: "z.B. /^\\d+$/ nur für Ziffern",
    min_value: "Minimalwert",
    max_value: "Maximalwert",
    less_than: "Kleiner als",
    more_than: "Größer als",
    positive_value: "Positiver Wert",
    negative_value: "Negativer Wert",
    integer_value: "Ganzzahl",

    // ─── Collection Editor — Property Edit ───────────────────────
    invalid_regular_expression: "Ungültiger regulärer Ausdruck",
    must_specify_target_collection: "Sie müssen eine Ziel-Sammlung für das Feld angeben",
    need_specify_repeat_field: "Sie müssen ein Wiederholungsfeld angeben",
    need_specify_block_properties: "Sie müssen die Eigenschaften dieses Blocks angeben",
    incomplete_condition: "Unvollständige Bedingung – bitte wählen Sie ein Feld",
    field_name: "Feldname",

    // ─── Collection Editor — Display & Config ────────────────────
    kanban_column_property: "Kanban-Spalten-Eigenschaft",
    select_a_property: "Eigenschaft auswählen",
    kanban_property_not_found: "Eigenschaft \"{{property}}\" existiert nicht oder ist keine Enum-String-Eigenschaft. Bitte wählen Sie eine gültige Eigenschaft oder löschen Sie die Auswahl.",
    no_enum_string_properties: "Keine Enum-String-Eigenschaften gefunden. Fügen Sie eine String-Eigenschaft mit enumValues hinzu, um die Kanban-Ansicht zu verwenden.",
    kanban_column_description: "Wählen Sie eine String-Eigenschaft mit Enum-Werten, um Entitäten in Spalten zu gruppieren",
    create_property: "+ Eigenschaft \"{{property}}\" erstellen",
    order_property: "Reihenfolge-Eigenschaft",
    order_property_not_found: "Eigenschaft \"{{property}}\" existiert nicht oder ist keine Zahlen-Eigenschaft. Bitte wählen Sie eine gültige Eigenschaft oder löschen Sie die Auswahl.",
    no_number_properties: "Keine Zahlen-Eigenschaften gefunden. Fügen Sie eine Zahlen-Eigenschaft hinzu, um die Sortierung zu aktivieren.",
    order_property_description: "Wählen Sie eine Zahlen-Eigenschaft, um die Reihenfolge der Elemente beizubehalten",
    display_settings: "Anzeigeeinstellungen",
    default_row_size: "Standard-Zeilengröße",
    side_dialog_width: "Seitendialog-Breite",
    side_dialog_width_description: "Optional die Breite (in Pixeln) des Seitendialogs für Entitäten definieren. Standard ist 768px",
    inline_editing_enabled: "Daten können direkt in der Tabellenansicht bearbeitet werden",
    inline_editing_disabled: "Daten können nur in der Formularansicht bearbeitet werden",
    inline_editing_description: "Ermöglicht das direkte Bearbeiten von Daten in der Tabellenansicht, ohne die Formularansicht zu öffnen.",
    include_json_view: "JSON-Ansicht einbeziehen",
    no_json_view: "JSON-Ansicht nicht einbeziehen",
    json_view_description: "Die JSON-Darstellung des Dokuments einbeziehen.",
    not_found_suffix: "nicht gefunden",

    // ─── Editor ─────────────────────────────────────────────────
    editor_text: "Text",
    editor_text_description: "Fangen Sie einfach an, Klartext zu tippen.",
    editor_heading_1: "Überschrift 1",
    editor_heading_1_description: "Große Bereichsüberschrift.",
    editor_heading_2: "Überschrift 2",
    editor_heading_2_description: "Mittlere Bereichsüberschrift.",
    editor_heading_3: "Überschrift 3",
    editor_heading_3_description: "Kleine Bereichsüberschrift.",
    editor_todo_list: "To-Do Liste",
    editor_todo_list_description: "Verfolgen Sie Aufgaben mit einer To-Do Liste.",
    editor_bullet_list: "Aufzählungsliste",
    editor_bullet_list_description: "Erstellen Sie eine einfache Aufzählungsliste.",
    editor_numbered_list: "Nummerierte Liste",
    editor_numbered_list_description: "Erstellen Sie eine nummerierte Liste.",
    editor_quote: "Zitat",
    editor_quote_description: "Erfassen Sie ein Zitat.",
    editor_code: "Code",
    editor_code_description: "Erfassen Sie einen Code-Ausschnitt.",
    editor_image: "Bild",
    editor_image_description: "Laden Sie ein Bild hoch.",
    editor_multiple: "Mehrere",
    editor_link: "Link",
    editor_save: "Speichern",
    editor_cancel: "Abbrechen",
    editor_remove_link: "Link entfernen",
    editor_paste_or_type_link: "Link einfügen oder eintippen",
    editor_open_in_new_window: "In neuem Fenster öffnen",
    editor_bold: "Fett",
    editor_italic: "Kursiv",
    editor_underline: "Unterstrichen",
    editor_strikethrough: "Durchgestrichen",
    editor_autocomplete: "Autovervollständigung",
    editor_autocomplete_description: "Fügen Sie Text basierend auf dem Kontext hinzu.",

    // ─── Cloud Project Settings ──────────────────────────────────
    settings_subscription_plan: "Abonnement-Plan",
    settings_subscribed_to: "Sie sind derzeit abonniert für",
    settings_no_active_subscription: "Derzeit besteht kein aktives Abonnement für dieses Projekt.",
    settings_trial_valid_until: "Ihre Testphase ist gültig bis {{date}}.",
    settings_features_intro: "Dies sind einige der Funktionen, die Sie bereits mit FireCMS Cloud genießen",
    settings_feature_managed_service: "Verwalteter, stets aktueller Service",
    settings_feature_local_text_search: "Lokale Textsuche",
    settings_feature_unlimited_users_roles: "Unbegrenzte Benutzer und Rollen",
    settings_feature_theme_logo: "Design- und Logo-Anpassung",
    settings_feature_custom_fields_views: "Benutzerdefinierte Formularfelder und Ansichten",
    settings_feature_secondary_databases: "Sekundäre Datenbanken",
    settings_feature_ai_content: "KI-Inhaltsgenerierung mit OpenAI und Google",
    settings_feature_unlimited_export: "Unbegrenzter Datenexport",
    settings_feature_appcheck: "AppCheck",
    settings_heading: "Einstellungen",
    settings_project_name: "Projektname",
    settings_default_language: "Standardsprache",
    settings_default_language_caption: "Wählen Sie die Basissprache für dieses Projekt. Benutzer können diese Einstellung in ihren persönlichen Einstellungen überschreiben.",
    settings_enable_local_text_search: "Lokale Textsuche aktivieren",
    settings_local_text_search_caption: "Aktivieren Sie die lokale Textsuche für alle Sammlungen. Dadurch können Sie Textfelder in Ihren Sammlungen über die FireCMS-Suchleiste durchsuchen. Beachten Sie, dass diese Funktion zu höheren Lesezahlen führen kann, da alle Textfelder in Ihren Sammlungen indexiert werden.",
    settings_doc_history_all_collections: "Dokumentverlauf für alle Sammlungen aktiviert",
    settings_doc_history_caption: "Wenn aktiviert, wird der Verlauf standardmäßig für alle Sammlungen aktiviert. Sie können diese Einstellung für jede Sammlung überschreiben. Der Verlauf wird in der Untersammlung __history jedes Dokuments gespeichert.",
    settings_theme: "Design",
    settings_primary_color: "Primärfarbe",
    settings_secondary_color: "Sekundärfarbe",
    settings_sample_theme_components: "Beispiel-Designkomponenten",
    settings_drag_drop_logo: "Ziehen Sie Ihr Logo hierher",
    settings_create_subscription: "Abonnement erstellen",
    settings_stripe_disclaimer: "Sie werden zu Stripe weitergeleitet, um Ihr Abonnement abzuschließen. Die Abrechnung erfolgt monatlich basierend auf Ihren maximalen Benutzern. Kündigen Sie jederzeit – Sie haben bereits für den aktuellen Abrechnungszeitraum bezahlt, daher fallen nach der Kündigung keine weiteren Gebühren an.",
    settings_subscription_is: "Das Abonnement ist",
    settings_next_payment_on: "Die nächste Zahlung ist am {{date}}.",
    settings_seats_count: "Sie haben",
    settings_seat: "Platz",
    settings_seats: "Plätze",
    settings_per_seat: "zu {{price}}/Platz/{{interval}}",
    settings_current_price: "Der aktuelle Preis beträgt",
    settings_per_user_usage: "pro Benutzer (nutzungsbasiert).",
    settings_cancelled_active_until: "Dieses Abonnement wurde gekündigt und bleibt aktiv bis {{date}}.",
    settings_no_additional_charges: "Nach der Kündigung fallen keine weiteren Gebühren an.",
    settings_manage_subscription: "Abonnement verwalten",
    settings_security_rules: "Sicherheitsregeln",
    settings_security_rules_description: "FireCMS verwendet Firebase-Sicherheitsregeln, um den Zugriff auf Daten einzuschränken. Beim Erstellen eines neuen Benutzers über FireCMS wird dem Benutzer im Client-Projekt das benutzerdefinierte Attribut fireCMSUser hinzugefügt. Durch Hinzufügen der folgenden Sicherheitsregeln stellen Sie sicher, dass FireCMS-Benutzer über FireCMS auf Daten zugreifen können.",
    settings_security_rules_add_domain: "Denken Sie daran, die Domain {{domain}} zu den erlaubten Domains Ihres Anbieters hinzuzufügen",
    settings_security_rules_caption: "Diese Regeln beschränken den Datenzugriff nur auf FireCMS-Benutzer, setzen die Berechtigungen jedoch nicht auf Datenbankebene durch. Die Berechtigungen werden im Frontend durchgesetzt, was für die meisten Projekte ausreichend ist. Wenn Sie die Berechtigungen auf Datenbankebene durchsetzen müssen, können Sie diese Sicherheitsregeln entsprechend anpassen. Die einem Benutzer zugewiesenen Rollen werden als benutzerdefinierte Attribute im Firebase-Authentifizierungstoken gespeichert, sodass Sie sie in Ihren Sicherheitsregeln verwenden können.",
    settings_appcheck: "AppCheck",
    settings_appcheck_description: "Sie können AppCheck aktivieren, um Ihre Firebase-Dienste vor Missbrauch zu schützen. Lesen Sie in der Firebase-Dokumentation, wie Sie es konfigurieren. Wenn Sie einen Anbieter eingerichtet haben, können Sie ihn hier aktivieren. Sie müssen ein Geheimnis in Ihren Firebase-Projekteinstellungen und einen Website-Schlüssel in der FireCMS-Konfiguration angeben.",
    settings_appcheck_add_domain: "Denken Sie daran, die Domain {{domain}} zu den erlaubten Domains Ihres Anbieters hinzuzufügen",
    settings_appcheck_enable: "AppCheck aktivieren",
    settings_appcheck_site_key: "Website-Schlüssel",
    settings_appcheck_update: "AppCheck aktualisieren",
    settings_appcheck_refresh_note: "Möglicherweise müssen Sie die Seite nach dem Speichern aktualisieren, um die Änderungen zu sehen.",
    settings_appcheck_updated: "AppCheck aktualisiert",
    settings_appcheck_error: "Fehler beim Aktualisieren von AppCheck",

    // ─── Text Search Dialog ─────────────────────────────────────
    text_search_dialog_title: "Textsuche aktivieren",
    text_search_local_not_recommended: "Die lokale Textsuche wird für große Sammlungen nicht empfohlen.",
    text_search_local_fetch_warning: "Beachten Sie, dass die lokale Textsuche alle Dokumente Ihrer Sammlung abrufen und im Browser speichern muss. Dies kann bei großen Sammlungen ineffizient sein und zusätzliche Kosten verursachen.",
    text_search_external_suggestion: "Für größere Sammlungen wird empfohlen, eine externe Suchmaschine wie Algolia oder Elastic Search zu verwenden und einen Suchdelegaten in Ihrer Konfiguration zuzuweisen.",
    text_search_local_description: "Die lokale Textsuche ist der einfachste Weg, die Textsuche in Ihrer Sammlung zu aktivieren. Sie lädt alle Dokumente der Sammlung im Browser und führt die Suche lokal durch. Dies ist die empfohlene Option für kleine Sammlungen.",
    text_search_own_implementation: "Sie haben Ihren eigenen Textsuch-Controller implementiert. Sie können die Textsuche für Ihre Sammlung aktivieren.",
    text_search_enable_for_collection: "Für diese Sammlung aktivieren",
    text_search_enable_for_project: "Für das Projekt aktivieren",
    text_search_enabled_snackbar: "Lokale Textsuche aktiviert"
};
